import React from 'react';
import venImageSrc from '../../assets/images/ven.png';
import familySrc from '../../assets/images/slide/family.png';
import styles from './TrustSlideV5.css';

function TrustSlideV5() {
    return (
        <div className={styles.root}>
            <img src={familySrc} alt='family' className={styles.image} />
            <h3 className={styles.title}>Your personal security check starts here</h3>
            <p className={styles.description}><strong>Futureproof</strong> keeps you safer online — with simple, automatic tools made for everyone.</p>
            <div className={styles.banner}>
                <img src={venImageSrc} alt='ven' />
                <h2 className={styles.bannerTitle}>24,000+ people are already secured by Futureproof</h2>
                <img src={venImageSrc} alt='ven' />
            </div>
        </div>
    );
}

export {
    TrustSlideV5
};
